export default __webpack_public_path__ + "static/media/Ente-und-Fisch.e2cdeda1.png";